import { render } from "./ModalChangePhone.vue?vue&type=template&id=87e34598"
import script from "./ModalChangePhone.vue?vue&type=script&lang=js"
export * from "./ModalChangePhone.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__